<template>
    <div class="alternate-form-age">
        <div class="alternate-form-component-container">
            <div class="alternate-form-component-container__icon-container">
                <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19.293 1.64062H17.4062V0.65625C17.4062 0.293836 17.1125 0 16.75 0C16.3875 0 16.0938 0.293836 16.0938 0.65625V1.64062H6.90625V0.65625C6.90625 0.293836 6.61245 0 6.25 0C5.88755 0 5.59375 0.293836 5.59375 0.65625V1.64062H3.70703C2.21435 1.64062 1 2.85497 1 4.34766V18.293C1 19.7857 2.21435 21 3.70703 21H19.293C20.7857 21 22 19.7857 22 18.293V4.34766C22 2.85497 20.7857 1.64062 19.293 1.64062ZM3.70703 2.95312H5.59375V3.60938C5.59375 3.97179 5.88755 4.26562 6.25 4.26562C6.61245 4.26562 6.90625 3.97179 6.90625 3.60938V2.95312H16.0938V3.60938C16.0938 3.97179 16.3875 4.26562 16.75 4.26562C17.1125 4.26562 17.4062 3.97179 17.4062 3.60938V2.95312H19.293C20.0619 2.95312 20.6875 3.5787 20.6875 4.34766V5.90625H2.3125V4.34766C2.3125 3.5787 2.93807 2.95312 3.70703 2.95312ZM19.293 19.6875H3.70703C2.93807 19.6875 2.3125 19.0619 2.3125 18.293V7.21875H20.6875V18.293C20.6875 19.0619 20.0619 19.6875 19.293 19.6875Z"
                        fill="#1B3C70"
                    />
                </svg>
            </div>
            <ValidationProvider
                v-slot="{ errors }"
                rules="birthday-required|birthday|overEighteen"
                tag="section"
                name="Geboortedatum"
            >
                <AlternateFormComponent
                    v-model="birthday"
                    v-mask="'##-##-####'"
                    name="age"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    :label="label"
                    :placeholder="placeholder"
                    :required="isRequired"
                    :hint="errors[0]"
                    :state="errors[0] ? 'error' : null"
                >
                </AlternateFormComponent>
            </ValidationProvider>
        </div>
        <div class="alternate-form-age__message">
            <p class="alternate-form-age__message-text">
                <b>SPEEL BEWUST 18+</b> <br />
                <small>
                    Om deel te nemen moet je minimaal 18 jaar zijn. <br />
                    Meer informatie over bewust & verantwoord spelen vind je op
                    <a href="https://www.speelbewust.nl/" target="_blank">speelbewust.nl</a>
                </small>
            </p>
        </div>
    </div>
</template>

<script>
import './alternate-form-age.scss';

import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { parse, sub, isMatch, isExists, isBefore, formatISO, format, parseISO } from 'date-fns';
import { mask } from 'vue-the-mask';

import AlternateFormComponent from './AlternateFormComponent.vue';

extend('birthday-required', {
    ...required,
    message: 'Geboortedatum is een verplicht veld',
});

function validDateFormat(value) {
    const [day, month, year] = value.split('-').map(v => parseInt(v));
    const allowedFormat = new RegExp('^[0-9]{2}-[0-9]{2}-[0-9]{4}$');

    return (
        isMatch(value, 'dd-MM-yyyy') &&
        isExists(year, month - 1, day) && // The month is 0-indexed, so we have to substract 1
        allowedFormat.test(value)
    );
}

extend('birthday', value => {
    if (validDateFormat(value)) {
        return true;
    }

    return 'Voer geboortedatum correct in';
});

extend('overEighteen', value => {
    const parsedDate = parse(value, 'dd-MM-yyyy', new Date());
    const ageLimit = sub(new Date(), { years: 18 });

    if (isBefore(parsedDate, ageLimit)) {
        return true;
    }

    return 'Oeps! Deelnemen kan alleen als je 18+ jaar bent';
});

export default {
    name: 'AlternateFormAge',
    directives: { mask },
    components: { ValidationProvider, AlternateFormComponent },
    props: {
        value: String,
        label: {
            type: String,
            default: 'Geboortedatum',
        },
        placeholder: {
            type: String,
            default: 'dd-mm-jjjj',
        },
        isRequired: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            birthday: this.value ? this.fromIsoDate(this.value) : '',
        };
    },
    watch: {
        birthday: {
            handler(newVal) {
                if (validDateFormat(newVal)) {
                    this.$emit('input', this.toIsoDate(newVal));
                    return;
                }

                this.$emit('input', newVal);
            },
        },
    },
    methods: {
        toIsoDate(date) {
            return formatISO(parse(date, 'dd-MM-yyyy', new Date()));
        },
        fromIsoDate(date) {
            return format(parseISO(date), 'dd-MM-yyyy');
        },
    },
};
</script>
